import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { GestionService } from "../../../../../services/gestion.service";

@Component({
    selector: 'app-marcas-pais-denominacion',
    templateUrl: './marcas-pais-denominacion.component.html'
})
export class MarcasPaisDenominacionComponent implements OnInit {


    public new = false;
    public editables;

    private _marcaId;
    private _paisId;
    private _denominacionId;

    public pais;
    public denominacion;

    private _filters;

    public allGrupoEtiquetasCaja;
    public allGrupoEtiquetasPallet;

    public toCloseSpinner = 0;

    public marcasPaisDenominacion;
    private _marcaPaisDenominacion;

    public marcasForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();
    public deleteModal = false;

    @Input() paisId: number;
    @Input() denominacionId: number;

    @Output() pushMessage = new EventEmitter<string>();
    @Output() refresh = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _dataProvider: DataProvider,
        private readonly _sessionContext: SessionContextService,
        private readonly _gestionService: GestionService,
        private readonly _spinnerService: SpinnerService,
        private readonly _translate: TranslateService
    ) {}

    ngOnInit() {
        const promises: Promise<any>[] = [];
        promises.push(this.getAllGruposEtiquetaCajas());
        promises.push(this.getAllGruposEtiquetaPallet());
        Promise.all(promises).then(
            () => {
                this._paisId = this.paisId;
                this._denominacionId = this.denominacionId;
                this._filters = {
                    paisId: this._paisId,
                    denominacionId: this._denominacionId,
                    cargaRegistroEnUso: true
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._gestionService.getMarcasPaisDenominacion(this._filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    this.marcasPaisDenominacion = resp.lista;
                });
                return true;
            }, (error) => {
                if (error.status === 420) {
                    this.pushMessage.emit('global.error.noAccess');
                } else {
                    this.pushMessage.emit('global.error.noResponse');
                }
            }
        ).catch(e => console.log(e));

        this.pais = this._dataProvider.paises.find(x => x.id === this.paisId);
        this.denominacion = this._dataProvider.denominaciones.find(x => x.id === this.denominacionId);
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get marcas() {
        return this._dataProvider.marcasPaisDenominacion;
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get denominaciones() {
        return this._dataProvider.denominaciones;
    }

    public reload() {
        this._filters = {
            paisId: this._paisId,
            denominacionId: this._denominacionId,
            cargaRegistroEnUso: true
        };
        this._spinnerService.showSpinner();
        this._gestionService.getMarcasPaisDenominacion(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
          }).then((resp) => {
            this.marcasPaisDenominacion = resp.lista;
        });
    }

    public getAllGruposEtiquetaCajas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 1
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._gestionService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasCaja = resp.lista;
                    var x = this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas');
                    this.allGrupoEtiquetasCaja.unshift({ id: 0, des: x });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getAllGruposEtiquetaPallet(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 2
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._gestionService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasPallet = resp.lista;
                    var x = this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas');
                    this.allGrupoEtiquetasPallet.unshift({ id: 0, des: x });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getGruposEtiqueta(marcaPaisDenominacion, number) {
        return marcaPaisDenominacion.gruposEtiquetaMarcaPaisDenominacion.filter(x => x.tipoConfeccionId === number);
    }

    public close() {
        this.deleteModal = false;
        this.refresh.emit(false);
    }

    public closeDeleteModal() {
        this.deleteModal = false;
    }

    public toRefresh(value) {
        this.new = false;
        this.editables = '';
        if (value) {
            this.reload();
            this.refresh.emit(true);
        }
    }

    public editableChanged(marcaPaisDenominacion) {
        this.editables = marcaPaisDenominacion;
        this.new = false;
    }

    public showMessages(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    public askDelete(marcaPaisDenominacion) {
        this._marcaId = marcaPaisDenominacion.marcaId;
        this._paisId = marcaPaisDenominacion.paisId;
        this._denominacionId = marcaPaisDenominacion.denominacionId;
        this.deleteModal = true;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}
